export const VERIFY_ACCOUNT_STEP_SUCCESS = 'verify_account_step_success';
export const VERIFY_ACCOUNT_STEP_FAILURE = 'verify_account_step_failure';
export const VERIFY_ACCOUNT_COMPLETE = 'verify_account_complete';
export const LOGIN_EVENT = 'login';
export const PAGE_LOAD = 'page_load';
export const PHONE_CALL_CLICK = 'phone_call_click';
export const NAV_CLICK = 'nav_click';

type EventPayload = Record<string, unknown> | undefined;

const pushEvent = (eventName: string, data?: EventPayload): void => {
  if (typeof window === 'undefined') return;
  const layer: any[] = (window as any).dataLayer || ((window as any).dataLayer = []);
  const payload = { event: eventName, ...(data || {}) };
  layer.push(payload);
};

export const emitVerifyAccountStepSuccess = (data?: EventPayload): void => {
  pushEvent(VERIFY_ACCOUNT_STEP_SUCCESS, data);
};

export const emitVerifyAccountStepFailure = (data?: EventPayload): void => {
  pushEvent(VERIFY_ACCOUNT_STEP_FAILURE, data);
};

export const emitVerifyAccountComplete = (data?: EventPayload): void => {
  pushEvent(VERIFY_ACCOUNT_COMPLETE, data);
};

export const emitLogin = (): void => {
  pushEvent(LOGIN_EVENT, { site: 'trips', method: 'password' });
};

export const emitLoginSSO = (): void => {
  pushEvent(LOGIN_EVENT, { site: 'trips', method: 'sso' });
};

export const emitLoginEmailOtp = (): void => {
  pushEvent(LOGIN_EVENT, { site: 'trips', method: 'email_otp' });
};

export const emitLoginSmsOtp = (): void => {
  pushEvent(LOGIN_EVENT, { site: 'trips', method: 'sms_otp' });
};

export const emitPageLoad = (data?: EventPayload): void => {
  pushEvent(PAGE_LOAD, data);
};

export const emitPhoneCallClickEvent = (data?: EventPayload): void => {
  pushEvent(PHONE_CALL_CLICK, data);
};

export const emitNavClick = (data?: EventPayload): void => {
  pushEvent(NAV_CLICK, data);
};
